import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

@Entity()
export class ANAusbildung extends AdornisEntity {
  static override _class = 'ANAusbildung';

  @Field(() => String)
  hoechsterSchulAbschluss: Maybe<string>;

  @Field(() => String)
  hoechsterBerufsAbschluss: Maybe<string>;
}
